import { IPromotion } from './Promotion';
import { IShoppingListItem } from './ShoppingList';
import RetailerOffer from '@/interfaces/RetailerOffer';

export class ProductShoppingListItem {
    public Id: string;

    public UniqueId: string;

    public Name: string;

    public Description: string;

    public Image: string;

    public Price: string;

    public Selected: boolean;

    public PromotionalItem: boolean;

    public ItemId: string;

    public Upc: string;

    constructor(id: string, name: string, description: string, image: string,
        price: string, selected: boolean, promotionalItem: boolean, itemId: string, upc: string,
        uniqueId: string) {
        this.Id = id;
        this.Name = name;
        this.Description = description;
        this.Image = image;
        this.Price = price;
        this.Selected = selected;
        this.PromotionalItem = promotionalItem;
        this.ItemId = itemId;
        this.Upc = upc || '';
        this.UniqueId = uniqueId || id;
    }

    public get hasOfferToDisplay(): boolean {
        return (this.Description !== null && this.Description !== undefined && this.Description !== '');
    }

    public static createFromShoppingListItem(item: IShoppingListItem) {
        if (item.product) {
            return new ProductShoppingListItem(item.product.id, item.name, item.product.name,
                item.product.image, item.product.price, true, false, item.product.itemId, item.product.upc, Math.random().toString());
        }
        return new ProductShoppingListItem(
            item.id.toString(),
            item.name,
            '',
            '',
            '',
            false,
            false,
            (item.ingredientId) ? item.ingredientId.toString() : '',
            '',
            Math.random().toString(),
        );
    }

    public static createFromPromotion(promo: IPromotion) {
        return new ProductShoppingListItem(promo.id.toString(), '', promo.productName,
            promo.productImage, promo.price, true, true, promo.itemId, promo.productUpc, promo.uniqueId.toString());
    }

    public static createFromRetailerOffer(ro: RetailerOffer, ingredientName: string) {
        return new ProductShoppingListItem(
            ro.Id,
            ingredientName,
            ro.Name,
            ro.Image,
            ro.Price,
            true,
            false,
            ro.ItemId,
            ro.Upc,
            Math.random().toString(),
        );
    }
}
